import * as portfolioStore from './store'

export function portfolioModule({ app, router, store }) {
  store.registerModule('portfolio', { ...portfolioStore, namespaced: true })
}

export const IS_BETA = false
